import React from 'react';
import { motion } from 'framer-motion';
import { Home, Phone, Mail } from 'lucide-react';
export function FeaturedListings() {
  return <section id="listings" className="py-24 bg-warmGray px-6" data-id="element-112">
      <div className="max-w-4xl mx-auto text-center" data-id="element-113">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-114">
          <div className="w-16 h-16 rounded-full border-2 border-gold flex items-center justify-center mx-auto mb-8" data-id="element-115">
            <Home className="w-7 h-7 text-gold" data-id="element-116" />
          </div>

          <span className="text-gold uppercase tracking-[0.2em] text-sm font-medium mb-4 block" data-id="element-117">
            Featured Listings
          </span>
          <h2 className="text-4xl md:text-5xl font-serif text-charcoal mb-6" data-id="element-118">
            Real Homes, <span className="italic" data-id="element-119">Real Prices</span>
          </h2>
          <p className="text-lg text-charcoal-light font-light leading-relaxed max-w-2xl mx-auto mb-10" data-id="element-120">
            We're integrating live MLS listings so you can browse real Las Vegas
            homes with accurate photos, prices, and details. In the meantime,
            Jenny can send you current listings tailored to your budget and
            preferred community.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-121">
            <a href="tel:+18583978218" className="inline-flex items-center gap-3 bg-gold text-white px-8 py-4 uppercase tracking-widest text-sm hover:bg-gold-dark transition-colors duration-300" data-id="element-122">
              <Phone className="w-4 h-4" data-id="element-123" />
              (858) 397-8218
            </a>
            <a href="mailto:jenny@jennygong.com" className="inline-flex items-center gap-3 border border-charcoal text-charcoal px-8 py-4 uppercase tracking-widest text-sm hover:bg-charcoal hover:text-white transition-colors duration-300" data-id="element-124">
              <Mail className="w-4 h-4" data-id="element-125" />
              Email Jenny
            </a>
          </div>
        </motion.div>
      </div>
    </section>;
}